export default __webpack_public_path__ + "static/media/DesktopOnly.f6b397a6.svg";